"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _FooterModule = _interopRequireDefault(require("../styles/components/Footer.module.css"));
var _PAUL_Logo_blue = _interopRequireDefault(require("../images/PAUL_Logo_blue.svg"));
var _PAUL_Logo_white = _interopRequireDefault(require("../images/PAUL_Logo_white.svg"));
var _reactRouterDom = require("react-router-dom");
var _constants = require("../utils/constants");
var _reactRedux = require("react-redux");
var _translations = require("../entities/translations");
var _functions = require("../utils/functions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Footer = _ref => {
  let {
    theme = _constants.defaultTheme,
    className = ''
  } = _ref;
  const isLight = theme === _constants.themeKey.light;
  const {
    [24]: tFooter = ''
  } = (0, _reactRedux.useSelector)(_translations.selectActiveTranslationsInterfaceUILocalizations, _functions.areEqual);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_FooterModule.default.footer, " ").concat(isLight ? _FooterModule.default.light : _FooterModule.default.dark, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: isLight ? _PAUL_Logo_blue.default : _PAUL_Logo_white.default,
    alt: "PAUL"
  })), /*#__PURE__*/_react.default.createElement("hr", {
    className: _FooterModule.default.short_line
  }), /*#__PURE__*/_react.default.createElement("span", null, tFooter), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://paul.tech",
    target: "_blank",
    rel: "noreferrer"
  }, "paul.tech")), [className, theme, tFooter]);
};
var _default = exports.default = Footer;